import { useTranslation } from 'react-i18next'
import PageSeo from '@/components/feature/PageSeo'
import { SITE_URL } from '@/utils/schema'
import { brandInfo } from '@/mocks/site'
import { weddingStories } from '@/mocks/weddingStories'
import { weddingStoriesFaqIds } from '@/mocks/weddingStoriesFaq'

export default function WeddingStoriesSeo() {
  const { t } = useTranslation()

  const collectionSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: t('weddingStories.title'),
    description: t('weddingStories.description'),
    url: `${SITE_URL}/wedding-stories`,
    inLanguage: 'en',
    isPartOf: {
      '@type': 'WebSite',
      name: brandInfo.name,
      url: SITE_URL,
    },
    hasPart: weddingStories.map((story) => ({
      '@type': 'Article',
      headline: `${story.couple} — ${story.type} in ${story.place}`,
      description: story.excerpt,
      image: story.coverImage,
      url: `${SITE_URL}${story.to}`,
      inLanguage: 'en',
    })),
  }

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    inLanguage: 'en',
    mainEntity: weddingStoriesFaqIds.map((id) => ({
      '@type': 'Question',
      name: t(`weddingStoriesFaq.items.${id}.q`),
      acceptedAnswer: {
        '@type': 'Answer',
        text: t(`weddingStoriesFaq.items.${id}.a`),
      },
    })),
  }

  return (
    <PageSeo
      title={t('seo.weddingStories.title')}
      description={t('seo.weddingStories.description')}
      path="/wedding-stories"
      schemas={[collectionSchema, faqSchema]}
    />
  )
}